import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import PublicationsList from './components/publications/PublicationsList';
import PublicationDetail from './components/publications/PublicationDetail';
import CollectionsPage from './components/publications/CollectionsPage';
import CategoryPublications from './components/publications/CategoryPublications';
import ContactPage from './components/ContactPage';
import InteractiveFeatures from './components/InteractiveFeatures';
import SearchResults from './components/search/SearchResults';
import AuthorPage from './components/about/AuthorPage';
import MissionPage from './components/about/MissionPage';
import ProjectHistoryPage from './components/about/ProjectHistoryPage';
import ContributePage from './components/about/ContributePage';
import UploadPage from './components/admin/UploadPage';
import SupportPage from './components/SupportPage';
import NotFound from './components/NotFound';

// Extend the Window interface to include gtag
declare global {
  interface Window {
    gtag?: (command: string, ...args: any[]) => void;
  }
}

function App() {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/about/author" element={<AuthorPage />} />
        <Route path="/about/mission" element={<MissionPage />} />
        <Route path="/about/history" element={<ProjectHistoryPage />} />
        <Route path="/about/contribute" element={<ContributePage />} />
        <Route path="/publications" element={<PublicationsList />} />
        <Route path="/publications/:id" element={<PublicationDetail />} />
        <Route path="/collections" element={<CollectionsPage />} />
        <Route path="/collections/:category" element={<CategoryPublications />} />
        <Route path="/interactive" element={<InteractiveFeatures />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/admin/upload" element={<UploadPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;